const LYSTER_IOS_APPID = '1231846690';

const APPSTORE_URL = `https://apps.apple.com/app/lyster/id${LYSTER_IOS_APPID}`,
      BUGSNAG_API_KEY = 'aaf9e8d8479499a4d58fe328ee4f0228',
      BUGSNAG_RELEASE_STAGE = 'production',
      LYSTER_ANDROID_PACKAGE_NAME = 'com.kingstinct.lyster',
      GOOGLEPLAY_URL = `https://play.google.com/store/apps/details?id=${LYSTER_ANDROID_PACKAGE_NAME}`,
      LYSTER_API_ENDPOINT = 'https://lyster.herokuapp.com/',
      PUSHER_API_KEY = '868263b607ac2317abdc',
      UNDO_DELAY_IN_SECONDS = 5,
      WEB_URL = 'https://lyster.app';

export {
  APPSTORE_URL,
  BUGSNAG_API_KEY,
  BUGSNAG_RELEASE_STAGE,
  GOOGLEPLAY_URL,
  LYSTER_ANDROID_PACKAGE_NAME,
  LYSTER_API_ENDPOINT,
  LYSTER_IOS_APPID,
  PUSHER_API_KEY,
  UNDO_DELAY_IN_SECONDS,
  WEB_URL,
};

export default {
  APPSTORE_URL,
  BUGSNAG_API_KEY,
  BUGSNAG_RELEASE_STAGE,
  GOOGLEPLAY_URL,
  LYSTER_ANDROID_PACKAGE_NAME,
  LYSTER_API_ENDPOINT,
  LYSTER_IOS_APPID,
  PUSHER_API_KEY,
  UNDO_DELAY_IN_SECONDS,
  WEB_URL,
};
